import React from 'react';
import ReactDOM from 'react-dom';
import NavMenuApp from './NavMenuApp';

const el = document.querySelector('#nav-menu .site-menu-content');
const data = window.NAV_MENU_DATA;

if (el && data) {
    ReactDOM.render(
        <NavMenuApp navMenu={data}/>
        ,
        el
    )
}
